export { default } from './Default';
export type { SpotlightProps } from './Default';
